export const applicanttrackingplacementsdata = [
  {
    Applicant: "John Smith",
    Job: "Software Engineer",
    Location: "San Francisco, CA",
    Joining_date: "15-04-2025",
    last_date: "01-04-2025",
    Status: "Accepted",
    Company: "Tech Innovations Inc.",
  },
  {
    Applicant: "Emily Davis",
    Job: "UX Designer",
    Location: "New York, NY",
    Joining_date: "01-05-2025",
    last_date: "20-04-2025",
    Status: "Pending",
    Company: "Creative Labs LLC",
  },
  {
    Applicant: "Michael Lee",
    Job: "Product Manager",
    Location: "Los Angeles, CA",
    Joining_date: "01-06-2025",
    last_date: "25-05-2025",
    Status: "Accepted",
    Company: "InnovateTech Solutions",
  },
  {
    Applicant: "Sophia Martinez",
    Job: "Data Analyst",
    Location: "Chicago, IL",
    Joining_date: "10-05-2025",
    last_date: "01-05-2025",
    Status: "Rejected",
    Company: "DataWorks Corp.",
  },
  {
    Applicant: "James Robinson",
    Job: "Full Stack Developer",
    Location: "Austin, TX",
    Joining_date: "20-05-2025",
    last_date: "05-05-2025",
    Status: "Pending",
    Company: "NextGen Systems",
  },
  {
    Applicant: "Lily Johnson",
    Job: "Graphic Designer",
    Location: "Boston, MA",
    Joining_date: "30-04-2025",
    last_date: "15-04-2025",
    Status: "Accepted",
    Company: "PixelCraft Studios",
  },
  {
    Applicant: "Lucas Wilson",
    Job: "Web Developer",
    Location: "Seattle, WA",
    Joining_date: "05-06-2025",
    last_date: "01-06-2025",
    Status: "Pending",
    Company: "WebDynamics",
  },
  {
    Applicant: "Amelia Brown",
    Job: "HR Manager",
    Location: "Miami, FL",
    Joining_date: "15-06-2025",
    last_date: "05-06-2025",
    Status: "Accepted",
    Company: "Global HR Solutions",
  },
  {
    Applicant: "Ethan Harris",
    Job: "Full Stack Developer",
    Location: "San Jose, CA",
    Joining_date: "01-07-2025",
    last_date: "20-06-2025",
    Status: "Pending",
    Company: "CodeSphere Technologies",
  },
  {
    Applicant: "Chloe Wilson",
    Job: "Business Analyst",
    Location: "Dallas, TX",
    Joining_date: "01-08-2025",
    last_date: "25-07-2025",
    Status: "Rejected",
    Company: "AnalyticsPro Inc.",
  },
  {
    Applicant: "Benjamin King",
    Job: "System Administrator",
    Location: "Denver, CO",
    Joining_date: "15-07-2025",
    last_date: "10-07-2025",
    Status: "Pending",
    Company: "SecureNet Solutions",
  },
  {
    Applicant: "Olivia Martinez",
    Job: "SEO Specialist",
    Location: "Houston, TX",
    Joining_date: "25-06-2025",
    last_date: "15-06-2025",
    Status: "Accepted",
    Company: "SearchEdge Marketing",
  },
  {
    Applicant: "Charlotte Taylor",
    Job: "Content Writer",
    Location: "Phoenix, AZ",
    Joining_date: "01-07-2025",
    last_date: "10-06-2025",
    Status: "Pending",
    Company: "Creative Content Co.",
  },
  {
    Applicant: "Daniel Carter",
    Job: "Product Designer",
    Location: "New York, NY",
    Joining_date: "01-06-2025",
    last_date: "15-05-2025",
    Status: "Rejected",
    Company: "DesignWorks Studio",
  },
  {
    Applicant: "Sophie Thomas",
    Job: "Digital Marketing Specialist",
    Location: "Atlanta, GA",
    Joining_date: "15-06-2025",
    last_date: "01-06-2025",
    Status: "Accepted",
    Company: "MarketEdge Digital",
  },
];
